export default "__VITE_ASSET__a1c72f3d__"